import { isWeb } from 'tamagui'

export const isPublic = isWeb && window.location.pathname.startsWith('/public/')

// Rotas acessíveis sem sessão: os session providers não fazem auth/upgrade
// nem redirecionam para o login quando o usuário está deslogado nelas.
export const GUEST_ROUTES = [
  '/sign_in/qr',
  '/users/sign_in',
  '/users/invitation/accept',
  '/users/password/new',
  '/users/password/edit',
]

export const isGuestRoute = (pathname: string) =>
  GUEST_ROUTES.includes(pathname)

// Segmentos estáticos de primeiro nível de app/ — mantidos em sincronia com o
// diretório de rotas. Qualquer outro path raiz (/:slug) é a página de vendas
// do produto, que funciona deslogada E logada (auth opcional).
const STATIC_ROOT_SEGMENTS = [
  // Visão do produtor. Precisa estar aqui: sem isso /admin_view e
  // /admin_view/courses/:id casam com isOptionalAuthRoute, os session
  // providers pulam o POST /auth/upgrade e o preview nunca autentica.
  'admin_view',
  'certificates',
  'channels',
  'enrollments',
  'home',
  'image_viewer',
  'onboarding',
  'orders',
  'pdfviewer',
  'public',
  'sign_in',
  'users',
]

export const ADMIN_VIEW_PREFIX = '/admin_view'

// Visão do produtor sobre a área do aluno. As telas são as mesmas do aluno; o
// que muda é a ausência de matrícula na URL — igual ao legado, onde o core
// troca /enrollments/:id por /admin_view quando não há enrollment.
export const isAdminViewRoute = (pathname: string) =>
  pathname === ADMIN_VIEW_PREFIX || pathname.startsWith(`${ADMIN_VIEW_PREFIX}/`)

const ENROLLMENT_COURSE_PATH =
  /^\/enrollments\/\d+\/courses\/(\d+)\/online_course(\/course_contents\/\d+|\/extra_contents)?$/

const ENROLLMENT_COMBO_PATH = /^\/enrollments\/\d+\/paths\/(\d+)$/

/**
 * Equivalente em preview de uma rota de aluno. O produtor não tem matrícula, e
 * as telas de aluno respondem unauthorized para ele — então quem cair numa
 * rota de aluno em modo preview é levado para a mesma tela sob /admin_view.
 * Sem equivalente conhecido, cai na home do preview.
 */
export const toAdminViewPath = (pathname: string) => {
  const pathMatch = ENROLLMENT_COMBO_PATH.exec(pathname)
  if (pathMatch) return `${ADMIN_VIEW_PREFIX}/paths/${pathMatch[1]}`

  const match = ENROLLMENT_COURSE_PATH.exec(pathname)
  if (!match) return ADMIN_VIEW_PREFIX

  const [, courseId, suffix] = match

  return `${ADMIN_VIEW_PREFIX}/courses/${courseId}${suffix ?? ''}`
}

// Página de vendas (/:slug) e preview de curso do combo (/:slug/courses/:id).
export const isOptionalAuthRoute = (pathname: string) => {
  const match = /^\/([^/]+)(\/courses\/\d+)?$/.exec(pathname)
  if (!match) return false

  return !STATIC_ROOT_SEGMENTS.includes(match[1])
}
